<script setup>
  import PagesRecordResultListChecks from "@pages/Records/Components/Result/ResultList/ListChecks.vue";

  defineOptions({
    name: "PagesRecordResultNonComplianceResults",
  });

  defineProps({
    patientId: {
      type: String,
      required: true,
    },
    recordId: {
      type: String,
      required: true,
    },
    nonComplianceRedlights: {
      type: Array,
      default: () => {
        return [];
      },
    },
  });

  defineEmits(["open:shareDialog"]);
</script>

<template>
  <section v-if="nonComplianceRedlights.length > 0">
    <h2 class="border-b-1 border-gray-200 pb-6 text-center text-2xl font-semibold print:font-normal">Adhärenz</h2>

    <div class="mt-8 space-y-4 print:break-before-avoid-page">
      <PagesRecordResultListChecks
        anchor-prefix="non_compliance"
        :patient-id="patientId"
        :record-id="recordId"
        :checks="nonComplianceRedlights"
        :test-id="getTestId('non-compliance')"
        @open:share-dialog="$emit('open:shareDialog')"
      />
    </div>
  </section>
</template>
